import React from "react";
//#region types
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { TodoOtherTypeSectionProps } from "models/propTypes/missingDocumentPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DimensionEnums } from "models/enums";
//#endregion
//#region components
import {
  VerticalFormField,
  FormFieldLayout,
  TextInput,
  ExpandableSection,
  ExpandableSectionSummary,
  DimensionChipSelector,
} from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const TodoOtherTypeSection: React.FC<TodoOtherTypeSectionProps> = ({ connect, hasDimensions, amount }) => {
  return (
    <>
      <ExpandableSection
        alwaysOpen
        summary={
          <ExpandableSectionSummary
            title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.ReasonForTransaction)}
          />
        }
      >
        <VerticalFormField<TextInputProps>
          Component={TextInput}
          {...connect("explanation")}
          label={TranslationKeys.Common.Reply}
          icon={IconDefinitionConstants.WCommentDots}
        />
      </ExpandableSection>
      {hasDimensions ? (
        <ExpandableSection
          summary={
            <ExpandableSectionSummary
              title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Tags)}
            />
          }
        >
          <DimensionChipSelector
            {...connect("other.dimensions")}
            amount={Math.abs(amount ?? 0)}
            type={DimensionEnums.DimensionCategory.MissingDocumentOther}
            layout={<FormFieldLayout direction="vertical" />}
          />
        </ExpandableSection>
      ) : (
        <></>
      )}
    </>
  );
};

export default TodoOtherTypeSection;
